var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 1.66699C5.4013 1.66699 1.66797 5.40033 1.66797 10.0003C1.66797 14.6003 5.4013 18.3337 10.0013 18.3337C14.6013 18.3337 18.3346 14.6003 18.3346 10.0003C18.3346 5.40033 14.6013 1.66699 10.0013 1.66699ZM9.16797 16.6087C5.8763 16.2003 3.33464 13.4003 3.33464 10.0003C3.33464 9.48366 3.4013 8.99199 3.50964 8.50866L7.5013 12.5003V13.3337C7.5013 14.2503 8.2513 15.0003 9.16797 15.0003V16.6087ZM13.3346 13.3337C14.0846 13.3337 14.7013 13.817 14.918 14.492C16.0013 13.3087 16.668 11.7337 16.668 10.0003C16.668 7.20866 14.943 4.81699 12.5013 3.82533V4.16699C12.5013 5.08366 11.7513 5.83366 10.8346 5.83366H9.16797V7.50033C9.16797 7.95866 8.79297 8.33366 8.33464 8.33366H6.66797V10.0003H11.668C12.1263 10.0003 12.5013 10.3753 12.5013 10.8337V13.3337H13.3346Z",
    fill: "#81909E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.af1a9ee6951d769ba89582553cb8c467.svg";
export { ForwardRef as ReactComponent };